import * as api from '../api';

const fetchCurrentTenantActions = api.fetchActions('tenant', 'fetch-current-tenant');

export const actionTypes = {
  ...fetchCurrentTenantActions.actionTypes
};

export const getCurrentTenantInfo = (enterpriseGuid) => api.getThunk(`/tenantInfo/${enterpriseGuid}`, null, fetchCurrentTenantActions);

